/* Onda 12.4 (2026-10-26): traduz nomes de frete vindos da Shopify (ex.: Local Delivery -> Entrega local) e mostra a entrega local primeiro na calculadora da pagina de produto. */
function thonyRateName(name) {
  var map = { 'local delivery': 'Entrega local', 'local pickup': 'Retirada na loja', 'pickup in store': 'Retirada na loja' };
  var key = String(name || '').trim().toLowerCase();
  return map[key] || name;
}

if (!customElements.get('shipping-calculator')) {
  class ShippingCalculator extends HTMLElement {
    constructor() {
      super();
      this.zip = this.querySelector('.js-zip-input');
      this.zip.addEventListener('keydown', this.handleZipKeydown.bind(this));
      this.button = this.querySelector('button');
      this.button.addEventListener('click', this.handleSubmit.bind(this));
    }

    init() {
      this.country = this.querySelector('.js-country-select');
      this.province = this.querySelector('.js-province-select');
      this.rates = this.querySelector('.js-rates');
      this.errors = this.querySelector('.js-errors');
      this.initialised = true;
    }

    /**
     * Handles submission of the rates calculator.
     * @param {object} evt - Event object.
     */
    async handleSubmit(evt) {
      evt.preventDefault();
      if (!this.initialised) this.init();

      this.errors.hidden = true;
      this.rates.hidden = true;
      this.button.disabled = true;
      this.button.classList.add('is-loading');

      const params = `shipping_address[zip]=${this.zip.value}&shipping_address[country]=${this.country.value}&shipping_address[province]=${this.province.value}`;

      try {
        const response = await fetch(`${theme.routes.cart}/shipping_rates.json?${params}`);
        const data = await response.json();

        if (response.ok) {
          this.showRates(data);
        } else {
          this.showErrors(data);
        }
      } catch (error) {
        console.log(error); // eslint-disable-line
      } finally {
        this.button.classList.remove('is-loading');
        this.button.disabled = false;
      }
    }

    /**
     * Handles keydown event on the zip code input.
     * @param {object} evt - Event object.
     */
    handleZipKeydown(evt) {
      if (evt.key === 'Enter') {
        evt.preventDefault();
        this.handleSubmit(evt);
      }
    }

    /**
     * Formats and shows a list of available shipping rates.
     * @param {object} data - Response data.
     */
    showRates(data) {
      const headingEl = this.rates.querySelector('.js-rates-heading');
      const textEl = this.rates.querySelector('.js-rates-text');
      textEl.innerHTML = '';

      if (data.shipping_rates && data.shipping_rates.length) {
        const headingLocaleStr = data.shipping_rates.length === 1 ? 'singleRate' : 'multipleRates';
        let rates = '';

        data.shipping_rates.forEach((rate) => {
          const formattedRate = theme.settings.moneyWithCurrencyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, rate.price);
          rates += `<li>${thonyRateName(rate.name)}: ${formattedRate}</li>`;
        });

        headingEl.hidden = false;
        headingEl.textContent = theme.strings.shippingCalculator[headingLocaleStr];
        textEl.innerHTML = `<ul class="styled-list">${rates}</ul>`;
      } else {
        headingEl.hidden = true;
        textEl.innerHTML = theme.strings.shippingCalculator.noRates;
      }

      this.rates.hidden = false;
    }

    /**
     * Formats and shows errors relating to rates retrieval.
     * @param {object} data - Response data.
     */
    showErrors(data) {
      let errors = '';

      Object.keys(data).forEach((key) => {
        errors += `<li>${data[key]}</li>`;
      });

      this.errors.querySelector('.js-errors-text').innerHTML = `<ul class="styled-list">${errors}</ul>`;
      this.errors.hidden = false;
    }
  }

  customElements.define('shipping-calculator', ShippingCalculator);
}

if (!customElements.get('product-shipping-calculator')) {
  class ProductShippingCalculator extends HTMLElement {
    connectedCallback() {
      this.zipInput = this.querySelector('.js-cep-input');
      this.button = this.querySelector('.js-cep-button');
      this.message = this.querySelector('.js-cep-message');

      this.loadSavedCEP();

      this.zipInput.addEventListener('input', this.handleCEPInput.bind(this));
      this.zipInput.addEventListener('keypress', this.handleKeypress.bind(this));
      this.button.addEventListener('click', this.handleSubmit.bind(this));
    }

    get shouldSaveCep() {
      return this.dataset.saveCep !== 'false';
    }

    loadSavedCEP() {
      if (!this.shouldSaveCep) return;
      const saved = localStorage.getItem('thony_shipping_cep');
      if (saved && saved.length === 8) {
        this.zipInput.value = saved.replace(/(\d{5})(\d)/, '$1-$2');
      }
    }

    saveCEP(cep) {
      if (!this.shouldSaveCep) return;
      const clean = cep.replace(/\D/g, '');
      if (clean.length === 8) localStorage.setItem('thony_shipping_cep', clean);
    }

    handleCEPInput(e) {
      let value = e.target.value.replace(/\D/g, '');
      if (value.length <= 8) {
        e.target.value = value.replace(/(\d{5})(\d)/, '$1-$2');
      }
    }

    handleKeypress(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        this.handleSubmit(e);
      }
    }

    getVariantId() {
      const form = document.querySelector('.js-product-form-main');
      if (form) {
        const input = form.querySelector('input[name="id"]');
        if (input && input.value) return input.value;
      }
      const input = document.querySelector('input[name="id"]');
      if (input && input.value) return input.value;
      return null;
    }

    async handleSubmit(e) {
      e.preventDefault();
      const zipRaw = this.zipInput.value.replace(/\D/g, '');

      if (zipRaw.length !== 8) {
        this.showError('Por favor, insira um CEP válido com 8 dígitos.');
        return;
      }

      const variantId = this.getVariantId();
      if (!variantId) {
        this.showError('Por favor, selecione uma variante do produto.');
        return;
      }

      this.button.textContent = 'Calculando...';
      this.button.disabled = true;
      this.message.innerHTML = '<p class="text-sm text-subdued mt-4">Calculando frete...</p>';

      this.saveCEP(zipRaw);

      try {
        await this.calculateShipping(zipRaw, variantId);
      } catch (err) {
        this.showError('Erro ao calcular frete. Por favor, tente novamente.');
      } finally {
        this.button.textContent = 'Calcular';
        this.button.disabled = false;
      }
    }

    showError(msg) {
      this.message.innerHTML = `<div class="alert bg-error-bg text-error-text mt-4">${msg}</div>`;
    }

    async getAddressFromCEP(cep) {
      try {
        const res = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
        const data = await res.json();
        if (data.erro) throw new Error('CEP não encontrado');
        return {
          street: data.logradouro || 'Rua',
          neighborhood: data.bairro || 'Centro',
          city: data.localidade || 'São Paulo',
          state: data.uf || 'SP'
        };
      } catch {
        return { street: 'Rua', neighborhood: 'Centro', city: 'São Paulo', state: 'SP' };
      }
    }

    async saveCartState() {
      const res = await fetch('/cart.js');
      return res.json();
    }

    async restoreCartState(cart) {
      await fetch('/cart/clear.js', { method: 'POST' });
      if (cart.items && cart.items.length > 0) {
        await Promise.all(
          cart.items.map((item) =>
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                id: item.variant_id,
                quantity: item.quantity,
                properties: item.properties
              })
            }).catch(() => {})
          )
        );
      }
    }

    async waitForItemInCart(variantId, attempts = 0) {
      if (attempts >= 10) return;
      const res = await fetch('/cart.js');
      const cart = await res.json();
      if (cart.items && cart.items.some((i) => i.variant_id == variantId)) return;
      await new Promise((r) => setTimeout(r, 200));
      return this.waitForItemInCart(variantId, attempts + 1);
    }

    async calculateShipping(zip, variantId) {
      const [originalCart, addressData] = await Promise.all([
        this.saveCartState(),
        this.getAddressFromCEP(zip)
      ]);

      try {
        await fetch('/cart/clear.js', { method: 'POST' });
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'xmlhttprequest' },
          body: JSON.stringify({
            id: parseInt(variantId),
            quantity: 1,
            properties: { _shipping_calc: 'true' }
          })
        });

        await this.waitForItemInCart(parseInt(variantId));

        const params = new URLSearchParams({
          'shipping_address[country]': 'Brazil',
          'shipping_address[province]': addressData.state,
          'shipping_address[zip]': zip,
          'shipping_address[city]': addressData.city,
          'shipping_address[address1]': addressData.street,
          'shipping_address[address2]': addressData.neighborhood
        });

        const res = await fetch(`/cart/shipping_rates.json?${params}`);
        const data = await res.json();

        if (data.shipping_rates && data.shipping_rates.length) {
          this.showRates(data.shipping_rates);
        } else {
          this.showError('Nenhuma opção de frete encontrada para este CEP.');
        }
      } finally {
        await this.restoreCartState(originalCart);
      }
    }

    showRates(rates) {
      rates = rates.slice().sort((a, b) => {
        const la = thonyRateName(a.name) === 'Entrega local' ? 0 : 1;
        const lb = thonyRateName(b.name) === 'Entrega local' ? 0 : 1;
        return la - lb;
      });
      let html = '<div class="mt-4 border border-default rounded">';

      rates.forEach((rate, i) => {
        const isLast = i === rates.length - 1;
        const price = parseFloat(rate.price);
        const priceHtml =
          price === 0
            ? '<span class="font-bold" style="color: var(--color-success, #51a559);">GRÁTIS</span>'
            : `<span class="font-bold">R$ ${rate.price.replace('.', ',')}</span>`;

        let deliveryInfo = '';
        if (rate.delivery_date) {
          const parts = rate.delivery_date.match(/(\d{4})-(\d{2})-(\d{2})/);
          deliveryInfo = parts ? `Entrega até ${parts[3]}/${parts[2]}` : `Entrega até ${rate.delivery_date}`;
        } else if (rate.description) {
          deliveryInfo = rate.description;
        } else if (rate.delivery_days && rate.delivery_days.length) {
          const d = new Date();
          d.setDate(d.getDate() + parseInt(rate.delivery_days[0]));
          deliveryInfo = `Entrega até ${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}`;
        }

        html += `<div class="flex justify-between items-start p-4${isLast ? '' : ' border-b border-default'}">
          <div>
            <div class="font-semibold text-sm">${thonyRateName(rate.name) || 'Frete'}</div>
            ${deliveryInfo ? `<div class="text-xs text-subdued mt-1">${deliveryInfo}</div>` : ''}
          </div>
          ${priceHtml}
        </div>`;
      });

      html += '</div>';
      this.message.innerHTML = html;
    }
  }

  customElements.define('product-shipping-calculator', ProductShippingCalculator);
}
